import { render, staticRenderFns } from "./SpentMoney.vue?vue&type=template&id=28e2c1d8&"
import script from "./SpentMoney.vue?vue&type=script&lang=js&"
export * from "./SpentMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports